export default __webpack_public_path__ + "8661c753a71cea2f29a8552406c39764.svg";